const pathPrefix = 'app-xfun';

export const INDEX = '/';
export const WALLET_CONNECT = '/wc';
export const TERMS = pathPrefix + '/tandc.html';
export const PRIVACY = pathPrefix + '/privacypolicy.html';
export const FAQ = pathPrefix + '/faq.html';
export const ABOUT = pathPrefix + '/aboutus.html';
export const RUBIC = pathPrefix + '/rubic.html';
